/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from '../../../tool';
import {WizAuthority} from '../../common'
import { WizModal } from "wiz-components";

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizAntdForm, WizButton, WizSpin} = component_tool;
let {Session} = utils_tool

const {Item} = WizAntdForm;

class BizDataMoveAddStudent extends WizContainer {
    componentName = 'BizDataMoveAddStudent';

    constructor(props) {
        super(props);
        this.state = {
          isLoading: false,
        };
    
        let {history} = this.props;
        if (history.location && history.location.record) {
          this.initialValue = history.location.record
          Session.set('dataInfo', this.initialValue)
        } else {
          this.initialValue = Session.get('dataInfo') || {}
        }

        console.log('initialValue',this.initialValue);

        let businessId
        if (this.initialValue.id) {
          businessId = this.initialValue.id
          Session.set('businessId',businessId)
        } else {
          businessId = Session.get('businessId')
        }
        console.log('businessId',businessId);
    }

    propsAndStateOnChange = {
      replaceStudent: this.addHandle.bind(this),
    }

    _render() {
        let  {isLoading} = this.state;
        let {form} = this.props
    
        return (
          <WizSpin spinning={isLoading}>
          <WizCard title={'批量设置'}>
            <WizAntdForm ref={(form) => this.form = form} labelCol={{span: 6}} wrapperCol={{span: 15}} >
                <Item label="新增的受众范围" >
                    {form.getFieldDecorator('newAuthInfo', {initialValue: {}})(
                    <WizAuthority
                        key={this.state.wizAuthorityKey}
                        mode={'Form'}
                        keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']}
                        hasRadioGroup={false}
                    />
                    )}
                </Item>
                <Item wrapperCol={{span: 12, offset: 6}}>
                    <WizButton title="保存" type="primary" htmlType="submit" onClick={this._onSubmit}>保存</WizButton>
                </Item>
            </WizAntdForm>
          </WizCard>
          </WizSpin>
        );
    }

    _onSubmit = (e) => {
        let businessId = Session.get('businessId')
        console.log('businessId',businessId);
    
        const {getFieldsValue} = this.props.form;
        let bizIdList = [];
        if (this.initialValue && this.initialValue.map) {
            bizIdList = this.initialValue && this.initialValue.map(data => {
            return data.bizId;
          }) || []
        }
    
        let data = getFieldsValue();
        let oldAuthInfo = {};
        let newAuthInfo = this.getDataAuth(data.newAuthInfo);
    
        const content = '你确认要批量新增这些受众吗？';
        WizModal.confirm({
            title: '注意',content,
            onOk: () =>{
              this.setState({
                isLoading: true,
              })
              this.doAction({
                path: 'bizDataMoveBiz/replaceStudent',
                payload: {
                  key: "replaceStudent",
                  apiParams: {oldAuthInfo,newAuthInfo,bizIdList,operationType: 1,permType: 1,businessId: businessId},
                }
              })
            },
            onCancel:()=>{
              this.setState({
                isLoading: false,
              })
            }
        })
    }

    getDataAuth(data = {}) {
      let {orgIds, positionIds, positionCategoryIds, personIds} = data;
      let temp = {};
  
      if (orgIds) {
        temp.orgIds = orgIds.map(tmp => tmp.id);
      }
      if (positionIds) {
        temp.positionIds = positionIds.map(tmp => tmp.id);
      }
      if (positionCategoryIds) {
        temp.positionCategoryIds = positionCategoryIds.map(tmp => tmp.id);
      }
      if (personIds) {
        temp.personIds = personIds.map(tmp => tmp.id);
      }
  
      return temp;
    }

    addHandle(nextProps, nextState) {
        nextState.isLoading = false;
        let o = nextProps['replaceStudent'] || {}
        let {code, success, msg, data} = o
        if (success) {
          wizNotice.success({
            duration: 4.5,
            message: <div dangerouslySetInnerHTML={{__html: data && JSON.stringify(data) !== '{}' ? data : msg}}/>
          })
          this.jumpPage('goBack');
        } else {
          wizNotice.error(msg)
        }
        return true;
    }
}


const mapStateToProps = (state, ownProps) => {
    const { bizDataMoveBiz } = state;
    const replaceStudent = modelUtils.getModelEntity(bizDataMoveBiz, 'replaceStudent');
    return {
      replaceStudent,
    }
};

export default WizAntdForm.create()(connect(mapStateToProps)(BizDataMoveAddStudent));